import React from "react";

/**
 * Chip standing in for a custom theme in chat text — the theme's first two colors, no name.
 * Extracted brand names are odd and positional labels ("Custom theme 1") go stale the moment a
 * theme is added or deleted, so the colors are the identity the user recognizes.
 */
export const ThemeSwatchBadge: React.FC<{ colors: string[] }> = ({ colors }) => {
  const shown = colors.slice(0, 2);
  return (
    <span
      className="inline-flex items-center gap-1 rounded-full border border-gray-200 bg-gray-100 px-2 py-0.5 align-middle text-sm cursor-default"
      title="Custom theme"
    >
      <span className="flex h-3.5 overflow-hidden rounded-full border border-gray-300">
        {shown.length > 0 ? (
          shown.map((color, i) => (
            <span key={i} className="block h-full w-3.5" style={{ backgroundColor: color }} />
          ))
        ) : (
          <span className="block h-full w-7 bg-gray-300" />
        )}
      </span>
      <span className="font-medium text-gray-900">theme</span>
    </span>
  );
};
